/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://lvcoyv7eac.execute-api.us-east-2.amazonaws.com/hyaat",
            "region": "us-east-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://hvwq3vfotrbcddgtecugrdwome.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-4kbgilc66vggnhcqjqs2q4bj5e",
    "aws_cognito_identity_pool_id": "us-east-2:8775bf7e-d54b-48cd-afbb-97b928bfacd2",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_Xi7rPq0yc",
    "aws_user_pools_web_client_id": "4o632j1f4ta7q4hqrgulbe9ef8",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL",
        "PHONE_NUMBER"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
